import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledTotalPriceWrapper = styled(Flexbox)`
    ${({theme: {spacing}}) => css`
        padding: ${spacing * 8}px 0 0;
    `}
`

export const StyledTextText = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        ${typography.textMd};
        color: ${palette.primary[950]};
    `
)

export const StyledTotalPrice = styled.div(
    ({theme: {palette, typography}}) => css`
        ${typography.displayMd};
        min-width: 150px;
        text-align: end;
        font-weight: 600;
        color: ${palette.primary[950]};
        border-bottom: 1px solid ${palette.primary[950]};
    `
)

export const StyledVatValue = styled.div(
    ({theme: {palette}}) => css`
        font-weight: 600;
        color: ${palette.primary[950]};
    `
)

export const StyledDivider = styled.div(
    ({theme: {palette, spacing}}) => css`
        border-top: 1px solid ${palette.neutral[300]};
        width: 100%;
        margin: ${spacing * 4}px 0 0;
        max-width: 450px;
    `
)

export const StyledTotalFinalPrice = styled.div(
    ({theme: {palette, typography}}) => css`
        ${typography.displayLg};
        min-width: 150px;
        text-align: end;
        font-weight: 600;
        color: ${palette.primary[950]};
        border-bottom: 1px solid ${palette.primary[950]};
    `
)
